import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { add } from 'date-fns';
import { ApiKey } from '@parashift/shared/models';
import { DatepickerFieldComponent, InputFieldComponent } from '@parashift/shared/components';
import { noop } from '@parashift/shared/utils';

@Component({
  selector: 'api-keys-edit-form',
  templateUrl: './api-keys-edit-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatepickerFieldComponent,
    InputFieldComponent,
    ReactiveFormsModule,
  ]
})
export class ApiKeysEditFormComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private datePipe = inject(DatePipe);
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true })
  set model(model) {
    this._model = model;
    this.initForm();
  }
  get model(): ApiKey['plainModel'] { return this._model; }
  private _model: ApiKey['plainModel'];

  @Input({ required: true })
  set disabled(disabled) {
    this._disabled = disabled;
    disabled ? this.form?.disable() : !this.model.id ? this.form?.enable() : noop();
  }
  get disabled(): boolean { return this._disabled; }
  private _disabled: boolean;

  @Input({ required: true }) tenantId: number;

  @Output() saveForm = new EventEmitter<ApiKey['plainModel']>();

  form: FormGroup;
  minDate = new Date();
  note = '';

  ngOnInit() {
    this.initForm();
    this.note = $localize `:@@components.api_keys.api_key_hint:This api key is only valid for the current tenant ${ this.tenantId }:tenantId:`;
  }

  submit() {
    this.form?.markAllAsTouched();
    this.form?.updateValueAndValidity({ emitEvent: true });
    this.cdr.detectChanges();
    this.form?.valid && this.emitForm();
  }

  private initForm() {
    this.form = undefined;
    this.form = this.formBuilder.group({
      name: [{ value: this.model.name ?? '', disabled: this.model.id ? true : false }, Validators.required],
      expires_at: [{ value: this.model.expires_at ?? this.datePipe.transform(add(new Date(), { months: 6 }), 'YYYY-MM-dd'), disabled: this.model.id ? true : false }, Validators.required]
    });
  }

  private emitForm() {
    const model = Object.assign(this.model, this.form.value);
    this.saveForm.emit(model);
  }
}
